import React, { useState, useEffect } from "react";
import "./Testimonials.css";
import YouTube from "react-youtube";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft, faAngleRight } from "@fortawesome/free-solid-svg-icons";

import "swiper/css";
import "swiper/css/pagination";

import { getWhatOurCustomerSays } from "../../../utils/apis/aboutus/Aboutus";

const Testimonials = () => {
  const [banner, setBanner] = useState([]);

  const getBanner = async () => {
    try {
      const res = await getWhatOurCustomerSays();

      if (res?.success) {
        setBanner(res?.data || []);
      }
    } catch (error) {
      console.error("Error fetching customer testimonials:", error);
    }
  };

  useEffect(() => {
    getBanner();
  }, []);

  // Extract YouTube video ID from URL
  const getYoutubeId = (url) => {
    if (!url) return null;

    try {
      const urlObject = new URL(url);

      // https://www.youtube.com/watch?v=gNlt8NjcMes
      if (urlObject.searchParams.get("v")) {
        return urlObject.searchParams.get("v");
      }

      // https://youtu.be/gNlt8NjcMes
      if (urlObject.hostname === "youtu.be") {
        return urlObject.pathname.replace("/", "");
      }

      return null;
    } catch (error) {
      console.error("Invalid YouTube URL:", url);
      return null;
    }
  };

const playerOptions = {
  width: "72",
  height: "72",
  playerVars: {
    autoplay: 0,
    controls: 1,
    modestbranding: 1,
    rel: 0,
    playsinline: 1,
  },
};
  return (
    <section className="Testimonials">
      <div className="container">
        <div className="What_Customer_Say_div">
          <div className="row align-items-center">
            <div className="col-lg-3 col-md-4">
              <div className="col_left_div">
                {/* <div className="qoute_div">
                  <img
                    src="/assets/images/home/testimonials/quote.png"
                    alt="Quote"
                    className="quote_img"
                  />
                </div> */}

                <div className="left_title_div">
                  <h5 className="left_title">
                    What <br /> Our Customers Say
                  </h5>

                  <p className="left_text">
                    Trusted by farmers who rely on our quality products and
                    consistent performance.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-lg-9 col-md-8 col-sm-12">
              <div className="testimonial_swiper_wrapper">
                <button
                  type="button"
                  className="testimonial_prev"
                  aria-label="Previous testimonial"
                >
                  <FontAwesomeIcon icon={faAngleLeft} />
                </button>

                <Swiper
                  modules={[Navigation, Pagination, Autoplay]}
                  loop={true}
                  spaceBetween={25}
                  allowTouchMove={true}
                  simulateTouch={true}
                  grabCursor={true}
                  touchRatio={1}
                  touchAngle={45}
                  threshold={5}
                  autoplay={{
                    delay: 3000,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: true,
                  }}
                  navigation={{
                    prevEl: ".testimonial_prev",
                    nextEl: ".testimonial_next",
                  }}
                  pagination={{
                    clickable: true,
                  }}
                  breakpoints={{
                    0: {
                      slidesPerView: 1,
                    },
                    576: {
                      slidesPerView: 1,
                    },
                    992: {
                      slidesPerView: 1.2,
                    },
                    1200: {
                      slidesPerView: 1.3,
                    },
                    1600: {
                      slidesPerView: 1.5,
                    },
                  }}
                >
                  {banner?.map((item) => {
                    const youtubeId = getYoutubeId(item?.description);

                    if (!youtubeId) {
                      return null;
                    }

                    return (
                      <SwiperSlide key={item.id}>
                        <div className="testimonial_video_card">
                          <div className="testimonial_media">
                            <YouTube
                              videoId={youtubeId}
                              opts={playerOptions}
                              className="youtube_player"
                            />
                          </div>

                          <a
                            href={item?.description}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="watch_btn"
                          >
                            Watch on YouTube
                          </a>
                        </div>
                      </SwiperSlide>
                    );
                  })}
                </Swiper>

                <button
                  type="button"
                  className="testimonial_next"
                  aria-label="Next testimonial"
                >
                  <FontAwesomeIcon icon={faAngleRight} />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
